module.exports = __webpack_public_path__ + "img/asus-zenfone-5.83125375.jpg";